export default __webpack_public_path__ + "static/media/playIcon.97b8727e.svg";